import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OrderItem {
  id: number;
  name: string;
}

export interface OrderDetailsState {
  service: string;
  customer?: string;
  employee?: string;
  employees?: string[];
  plateNumber: string;
  company: string;
  addOns: string[];
}

const initialState: OrderDetailsState = {
  service: "",
  customer: "",
  employee: "",
  employees: [],
  plateNumber: "KAD334R",
  company: "66cb052ca8764c9ee61b06bc",
  addOns: [],
};

const createOrderDetailsSlice = createSlice({
  name: "createOrderDetails",
  initialState,
  reducers: {
    setCreateOrderDetails: (
      state,
      action: PayloadAction<OrderDetailsState>
    ) => {
      state.service = action.payload.service || "";
      state.customer = action.payload.customer || "";
      state.employee = action.payload.employee || "";
      state.employees = action.payload.employees || [];
      state.plateNumber = action.payload.plateNumber || "";
      state.company = action.payload.company || "";
      state.addOns = action.payload.addOns || [];
    },
    clearCreateOrderDetails: (state) => {
      state.service = "";
      state.customer = "";
      state.employee = "";
      state.employees = [];
      state.plateNumber = "";
      state.company = "";
      state.addOns = [];
    },
  },
});

export const { setCreateOrderDetails, clearCreateOrderDetails } =
  createOrderDetailsSlice.actions;
export default createOrderDetailsSlice.reducer;
